import { Text } from "@chakra-ui/react";
import { formatBRL } from "../lib/currency";

export default function CurrencyText({ value, mono = false, ...rest }) {
  return (
    <Text as="span" fontFamily={mono ? "mono" : undefined} {...rest}>
      {formatBRL(value)}
    </Text>
  );
}
